import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import { AccountLocation, LocationSeachResult } from '../../types/location';

export type LocationsQueryParams = {
  q: string;
};
export type AccountLocationsQueryParams = {
  accountId: string;
  q: string;
};

export async function getLocations(query: LocationsQueryParams): Promise<ApiResponse<LocationSeachResult[]>> {
  return requestWithQuery({ url: '/care/locations/search', method: 'GET', params: query });
}
export async function getAccountLocations(query: AccountLocationsQueryParams): Promise<ApiResponse<AccountLocation[]>> {
  return requestWithQuery({ url: '/care/account_locations', method: 'GET', params: query });
}
